<template>
  <v-card>
    <v-card-title class="justify-center bgGrey">
      <span class="font-weight-bold title text-caption">Legenda:</span>
    </v-card-title>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: "sea-legend",
};
</script>
